import { motion } from "framer-motion";
import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import { MAPS_EMBED, PHONE, WHATSAPP } from "../../data";
import { Reveal } from "./Reveal";

export const LocationSection = () => (
    <section
        id="ubicacion"
        data-testid="location-section"
        className="py-20 md:py-28 px-4"
    >
        <div className="max-w-6xl mx-auto">
            <Reveal className="text-center mb-12">
                <span className="font-label uppercase tracking-[0.25em] text-xs text-strawred font-semibold">
                    Ven a vernos
                </span>
                <h2 className="mt-3 font-display font-bold text-4xl md:text-6xl text-gradient-pink">
                    Encuéntranos 📍
                </h2>
            </Reveal>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
                <Reveal className="order-2 lg:order-1">
                    <div className="h-full bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-hotpink/10 border border-pink-50 flex flex-col justify-center">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 shrink-0 rounded-2xl bg-hotpink/10 text-hotpink grid place-items-center">
                                <MapPin strokeWidth={2.5} />
                            </div>
                            <div>
                                <h3 className="font-display font-bold text-xl text-[#1a0a10]">
                                    Dirección
                                </h3>
                                <p className="text-[#6e4b58] font-medium">
                                    Plaza Cortes Leonesas, León
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4 mt-6">
                            <div className="w-12 h-12 shrink-0 rounded-2xl bg-hotpink/10 text-hotpink grid place-items-center">
                                <Clock strokeWidth={2.5} />
                            </div>
                            <div>
                                <h3 className="font-display font-bold text-xl text-[#1a0a10]">
                                    Horario
                                </h3>
                                <p className="text-[#6e4b58] font-medium">
                                    Consulta nuestro horario en Instagram
                                </p>
                            </div>
                        </div>

                        <div className="mt-8 flex flex-col sm:flex-row gap-3">
                            <motion.a
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                href={PHONE}
                                data-testid="call-button"
                                className="flex-1 inline-flex items-center justify-center gap-2 bg-hotpink text-white font-display font-semibold px-6 py-4 rounded-full shadow-lg shadow-hotpink/30"
                            >
                                <Phone size={20} /> Llamar 📞
                            </motion.a>
                            <motion.a
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                href={WHATSAPP}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="whatsapp-button"
                                className="flex-1 inline-flex items-center justify-center gap-2 bg-white text-hotpink border-2 border-hotpink font-display font-semibold px-6 py-4 rounded-full"
                            >
                                <MessageCircle size={20} /> WhatsApp 💬
                            </motion.a>
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.12} className="order-1 lg:order-2">
                    <div className="h-full min-h-[320px] rounded-3xl overflow-hidden shadow-xl shadow-hotpink/10 border-4 border-white">
                        <iframe
                            title="Mapa Plaza Cortes Leonesas León"
                            data-testid="map-embed"
                            src={MAPS_EMBED}
                            className="w-full h-full min-h-[320px]"
                            style={{ border: 0 }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                        />
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
